var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/dialog-close/dialog-close.html';
var html = "<div class=md-dialog-action-buttons> <md-button class=md-icon-button aria-label=Close ng-click=$ctrl.close()> <md-tooltip md-direction=bottom>Close</md-tooltip> <md-icon md-font-set=material-icons>close</md-icon> </md-button> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/common/dialog-close/dialog-close.html
// module id = 591
// module chunks = 0